import axios from 'axios';
import * as types from "../constants";

export const getChartTitles = (year) => async dispatch => {
  try {
    const res = await axios.post('/api/poinsettias/list', { year })

    dispatch({
      type: types.GET_CHART_TITLES,
      payload: res.data
    })
  } catch (e) {
    console.error(e);
  }
}

export const getYears = () => async dispatch => {
  try {
    const res = await axios.get('/api/poinsettias/years');
    let o = []
    for(let i of res.data) {
      console.log(i)
      o.push({ "value": i.year, "label": i.year })
    }

    dispatch({
      type: types.GET_YEARS,
      payload: o
    })
  } catch (e) {
    console.error(e);
  }
}

export const getChart = (chartId) => async dispatch => {
  try {
    let res = await axios.post('/api/poinsettias/search', {chartId});
    dispatch({
      type: types.SELECT_CHART,
      payload: res.data

    })
  } catch (e) {
    console.error(e);
  }
}

export const createNew = (data) => async dispatch => {
  try {
    let res = await axios.post('/api/poinsettias/newPoinsettia', data)
    dispatch({
      type: types.CREATE_CHART,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const copyChart = (data) => async dispatch => {
  try {
    let res = await axios.post('/api/poinsettias/copyPoinsettia', data)
    dispatch({
      type: types.COPY_CHART,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const editChart = ( id, data) => async dispatch => {
  try {
    let res = await axios.post('/api/poinsettias/updatePoinsettia', {id, data})
    dispatch({
      type: types.EDIT_CHART,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const addChemicals = (id, data) => async dispatch => {
  try {
    console.log(id, data);
    let res = await axios.post('/api/poinsettias/addChemical', {id, data})
    dispatch({
      type: types.ADD_CHEMICAL,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const addMeasurement = (id, data) => async dispatch => {
  try {
    let res = await axios.post('/api/poinsettias/addMeasurement', {id, data})
    dispatch({
      type: types.ADD_MEASUREMENT,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const addLevel = (id, data) => async dispatch => {
  try {
    let res = await axios.post('/api/poinsettias/addLevel', {id, data})
    console.log(res)
    dispatch({
      type: types.ADD_LEVEL,
      payload: res.data
    })
  } catch(e) {
    console.error(e);
  }
}

export const clearPoinsettia = () => async dispatch => {
  dispatch({
    type: types.CLEAR_POINSETTIA
  })
}

export const deleteChart = (id) => async dispatch => {
  try {
    let res = await axios.post('/api/poinsettias/deleteChart', {id:id});
    console.log(res)
    dispatch({
      type: types.DELETE_CHART
    })
  } catch(e) {
    console.error(e);
  }
}

export const updateTable = (table, index, e)=> async dispatch => {
  let name = e.target.name;
  let value = e.target.value;
  if(name === ("measurement" || "ph" || "ec")){
    table[index][name] = Number(value);
  } else {
    table[index][name] = value;
  }

  dispatch({
    type: types.UPDATE_TABLE,
    payload: table
  })
}

export const saveTable = (id, table) => async dispatch => {
  try {
    let res = await  axios.post('/api/poinsettias/saveTable', {id, table});
    dispatch({
      type: types.SAVE_TABLE,
      payload: res.data
    })
    console.log(res);
  } catch (e) {

  }
}

export const changeDate = (e) => async dispatch => {
  console.log(e)
  dispatch({
    type: types.CHANGE_DATE,
    payload: e.value
  })
}

export const poinsettiaCleanUp = () => async dispatch => {
  dispatch({
    type: types.POINSETTIA_CLEAN_UP
  })
}
